import { displayCurrency } from '@/utils/format.utils';
import type { ColumnDef } from '@tanstack/vue-table';
import { h } from 'vue';
import type { ModelInvoiceDetailedFeeResponse } from '@layup/api-sdk';

const displayMoneyValue = (value: string) => h('div', displayCurrency(Number(value)));

export const tableColumns: ColumnDef<ModelInvoiceDetailedFeeResponse>[] = [
  {
    accessorKey: 'description',
    header: 'Description',
    enableSorting: false,
    cell: ({ getValue }) => {
      const value = (getValue() as string) || '_';
      return h('div', value);
    },
  },
  {
    accessorKey: 'amountExclVAT',
    header: 'Amount - Excl VAT',
    enableSorting: false,
    cell: ({ getValue }) => {
      const value = getValue() as string;
      return displayMoneyValue(value);
    },
  },
  {
    accessorKey: 'VAT',
    header: 'VAT',
    enableSorting: false,
    cell: ({ getValue }) => {
      const value = getValue() as string;
      return displayMoneyValue(value);
    },
  },
  {
    accessorKey: 'amountInclVAT',
    header: 'Amount - Incl VAT',
    enableSorting: false,
    cell: ({ getValue }) => {
      const value = getValue() as string;
      return displayMoneyValue(value);
    },
  },
  {
    accessorKey: 'orderReference',
    header: 'Order Reference',
    enableSorting: false,
    cell: ({ getValue }) => {
      const value = (getValue() as string) || '_';
      return h('div', value);
    },
  },
  {
    accessorKey: 'id',
    header: 'Fee ID',
    enableSorting: false,
    cell: ({ getValue }) => {
      const value = getValue() as string;
      return h('div', value);
    },
  },
];
